import PubSub from 'underpub-js';
import gsap from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

const ButtonPrimary = function(options) {
  this.options = {
    $el: false,
  };

  this.data = {
    baseClass: 'atom-ButtonPrimary',
  };

  $.extend(true, this.options, options);
};

ButtonPrimary.prototype.init = function() {
  const self = this;

  self.$text = self.options.$el.find(`.${self.data.baseClass}__text`);

  gsap.set(self.$text, {
    backgroundSize: '0% 2px, 100% 2px',
  });

  PubSub.subscribe('loaded', () => self.initOnScrollAnimation());
};

ButtonPrimary.prototype.initOnScrollAnimation = function() {
  const self = this;

  gsap.to(self.$text, {
    onComplete: () => {
      self.$text.addClass('loaded');
      gsap.set(self.$text, { clearProps: 'all' });
    },
    duration: 0.7,
    scrollTrigger: {
      trigger: self.options.$el[0],
      start: 'top 95%',
    },
    ease: 'expo.easeout',
    backgroundSize: '100% 2px, 0% 2px',
  });
};

export default ButtonPrimary;
